<style lang="scss" scoped>
.spinner-background {
        display: flex;
        align-items: center;
        pointer-events: none;
        width: 100vw;
        height: 100vh;

        .spinner {
            width: 16px;
            height: 16px;
            &:before {
                left: -28px;
                width: 16px;
                height: 16px;
            }
            &:after {
                left: 28px;
                width: 16px;
                height: 16px;
            }
        }
    }
</style>

<template>
<div>
    <div
        class="spinner-background"
        v-if="pageLoading"
    >
        <div class="spinner"></div>
    </div>
    <template v-else>
        <router-view :translations="translations"></router-view>
        <modals-container></modals-container>
    </template>
</div>
</template>

<script>
export default {
    props: {
        translations: {
            type: Object,
            required: true,
            default: () => {
                return {}
            }
        }
    },
    computed: {
        pageLoading () {
            return this.$store.getters['dayConfigurator/pageLoading'];
        }
    },
}
</script>